export const SorterColumnDataType = {
  STRING: 'STRING',
  BOOLEAN_YES_NO: 'BOOLEAN_YES_NO',
  NUMERIC: 'NUMERIC',
  ENUM: 'ENUM',
  ARRAY: 'ARRAY',
  USER_MINI: 'USER_MINI',
  MILESTONE: 'MILESTONE',
};
